// file: src/KalkulatorRadniStaz.js

import React, { useState } from 'react';
import './Kalkulator.css';
import { FaCalendarAlt } from 'react-icons/fa';

// Helper za dohvat današnjeg datuma u "YYYY-MM-DD" formatu
function todayDateString() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

function KalkulatorRadniStaz() {
  const [ranijiGodine, setRanijiGodine] = useState(0);
  const [ranijiMjeseci, setRanijiMjeseci] = useState(0);
  const [ranijiDani, setRanijiDani] = useState(0);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [koristiTrenutni, setKoristiTrenutni] = useState(false);

  const [rezultat, setRezultat] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);

  const handleCheckbox = (e) => {
    setKoristiTrenutni(e.target.checked);
    if (e.target.checked) {
      setEndDate(todayDateString());
    } else {
      setEndDate('');
    }
  };

  const handleIzracunaj = async () => {
    setErrorMsg(null);
    setRezultat(null);

    // --- validacija ---
    if (startDate === '') {
      setErrorMsg('Molimo unesite datum početka zaposlenja.');
      return;
    }
    if (!koristiTrenutni && endDate === '') {
      setErrorMsg('Molimo unesite datum završetka zaposlenja ili čekirajte “trenutno radim”.');
      return;
    }
    // format JSON
    const payload = {
      raniji_godine: ranijiGodine,
      raniji_mjeseci: ranijiMjeseci,
      raniji_dani: ranijiDani,
      start_date: startDate,
      end_date: koristiTrenutni ? todayDateString() : endDate
    };

    try {
      const res = await fetch('https://kalkulator-backend-wvj6.onrender.com/radni-staz/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || 'Greška pri izračunu.');
      }
      const data = await res.json();
      setRezultat(data);
    } catch (err) {
      setErrorMsg(err.message);
    }
  };

  return (
    <div className="container">
      {/* ----- UNOSNI DIO ----- */}
      <div className="form-container card">
        <div className="form-header">
          <h2>
            Kalkulator radnog staža <FaCalendarAlt />
          </h2>
        </div>

        {/* Raniji staž */}
        <div className="field-group">
          <label className="field-label">
            Raniji radni staž:
          </label>
          <div style={{ display: 'flex', gap: '8px' }}>
            <div>
              <input
                type="number"
                min="0"
                className="field-input"
                value={ranijiGodine}
                onChange={(e) => setRanijiGodine(parseInt(e.target.value, 10))}
                placeholder="godine"
              />
              <small>god.</small>
            </div>
            <div>
              <input
                type="number"
                min="0"
                max="11"
                className="field-input"
                value={ranijiMjeseci}
                onChange={(e) => setRanijiMjeseci(parseInt(e.target.value, 10))}
                placeholder="mjeseci"
              />
              <small>mj.</small>
            </div>
            <div>
              <input
                type="number"
                min="0"
                max="30"
                className="field-input"
                value={ranijiDani}
                onChange={(e) => setRanijiDani(parseInt(e.target.value, 10))}
                placeholder="dani"
              />
              <small>dn.</small>
            </div>
          </div>
        </div>

        {/* Datum početka */}
        <div className="field-group">
          <label htmlFor="startDate" className="field-label">
            Datum početka zaposlenja<span className="required">*</span>:
          </label>
          <input
            type="date"
            id="startDate"
            className="field-input"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        {/* Datum završetka ili trenutno */}
        <div className="field-group">
          <label htmlFor="endDate" className="field-label">
            Datum završetka zaposlenja<span className="required">*</span>:
          </label>
          <input
            type="date"
            id="endDate"
            className="field-input"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            disabled={koristiTrenutni}
          />
          <label style={{ marginLeft: '8px', display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              checked={koristiTrenutni}
              onChange={handleCheckbox}
            />
            <span style={{ marginLeft: '4px' }}>Trenutno radim</span>
          </label>
        </div>

        {/* Gumb “Izračunaj” */}
        <div style={{ marginTop: '16px' }}>
          <button className="field-input" onClick={handleIzracunaj}>
            Izračunaj
          </button>
        </div>

        {errorMsg && (
          <div className="error-text" style={{ marginTop: '12px' }}>
            {errorMsg}
          </div>
        )}
      </div>

      {/* ----- REZULTATI ----- */}
      <div className="results-container card" style={{ marginTop: '20px' }}>
        {rezultat && (
          <>
            <h3 className="section-title">Rezultati</h3>
            <div className="results-section">
              <div className="result-row">
                <span>Ukupan radni staž:</span>
                <span>
                  {rezultat.ukupno_godine} god. {rezultat.ukupno_mjeseci} mj. {rezultat.ukupno_dani} dn.
                </span>
              </div>
              <div className="result-row">
                <span>Sljedeća puna godina staža:</span>
                <span>
                  {new Date(rezultat.next_anniversary)
                    .toLocaleDateString('sr-RS')}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default KalkulatorRadniStaz; // Ili preimenujte po želji
